import { Component, Input, OnInit } from '@angular/core';
import { Test } from 'src/app/models/test.model';

@Component({
  selector: 'ct-level-bar',
  templateUrl: './level-bar.component.html',
  styleUrls: ['./level-bar.component.scss']
})
export class LevelBarComponent implements OnInit {

  @Input() value: number;
  @Input() adnSkill: any;
  @Input() hide: boolean;
  @Input() colors: any;

  constructor() { }

  ngOnInit(): void { }

}
